import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../components/api/AxiosInstance'; 
import { useNavigate } from 'react-router-dom';
import Loading from './Loading';
import Search from './Search';

export default function Workers() {
  const { id } = useParams(); // Extract ID from URL
  const [department, setDepartment] = useState([]);


  
  const [filteredWorkers, setFilteredWorkers] = useState([]);
  const [filterStatus, setFilterStatus] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const workersPerPage = 10;
  const navigate = useNavigate();


  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');



  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    if (id) {
      axiosInstance.get(`/users_by_company_id?company_id=${id}`, {
        headers: {
          "ngrok-skip-browser-warning": "true",
        },
      })
        .then((response) => {
          setDepartment(response.data);
          setFilteredWorkers(response.data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching department details:', error);
          setIsLoading(false);
        });
    }
  }, [id]);

  const filterWorkers = (status) => {
    setFilterStatus(status);
    setCurrentPage(1);
    if (status === null) {
      setFilteredWorkers(department);
    } else {
      setFilteredWorkers(department?.filter(worker => worker.work_status === status));
    }
  };




  const goToDepartmentDetail = (id) => {
    navigate(`/worker/${id}`);
  };

  const indexOfLastWorker = currentPage * workersPerPage;
  const indexOfFirstWorker = indexOfLastWorker - workersPerPage;
  const currentWorkers = filteredWorkers?.slice(indexOfFirstWorker, indexOfLastWorker);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  useEffect(() => {
    // Filter orders based on search query
    if (searchQuery === '') {
      setFilteredWorkers(department);
    } else {
      const filtered = department.filter((order) =>
        order.name &&
        order.name.toLowerCase().includes(searchQuery.toLowerCase()) 
      );
      console.log('Filtered Orders:', filtered); // Debugging output
      setFilteredWorkers(filtered);
    }
  }, [searchQuery, department ]);

  const deleteDepartment = async (id) => {
    const isConfirmed = window.confirm('Bu ishchini oʻchirib tashlamoqchimisiz?');
  
    if (!isConfirmed) {
      return; // Exit the function if the user cancels the confirmation dialog
    }
  

    window.location.reload();
    try {
      await axiosInstance.delete(`/worker/${id}`);
      console.log('Department deleted');
    } catch (error) {
      console.error('Error deleting department:', error);
    } finally {
  
    }
  };

  if (loading || isLoading) {
    return <Loading />;
  }

  return (
    <div>
     <Search  onSearch={setSearchQuery}/>
     <div>
      <div className='two-btn'>
        <button onClick={() => filterWorkers(null)} className={filterStatus === null ? 'active' : ''}>Barcha ishchilar</button>
        <button onClick={() => filterWorkers(true)} className={filterStatus === true ? 'active' : ''}>Hozirgi ishchilar</button>
        <button onClick={() => filterWorkers(false)} className={filterStatus === false ? 'active' : ''}>Ishlamaydigan ishchilar</button>
      </div>

      <div className="update1">
        <div className='update-table0'>
        <div className="update-table1">
          <div className="dnum"><h5>№</h5></div>
          <div className="img_car"><h5>Surati</h5></div>
          <div className="worker-item"><h5>Ism</h5></div>
          <div className="worker-item"><h5>Familiyasi</h5></div>
          <div className="worker-item"><h5>Otasining ismi</h5></div>
          <div className="worker-item"><h5>Tug'ilgan sana</h5></div>
          <div className="worker-item"><h5>Uy manzili</h5></div>
          <div className="worker-item"><h5>Lavozimi</h5></div>
        </div>
      
        </div>

        {currentWorkers?.map((e, index) => (
          <div className='update-table0'>

          <div className="update-table1 map" key={e.id} onClick={() => goToDepartmentDetail(e.id)}>
            <div className="dnum"><h5>{indexOfFirstWorker + index + 1}</h5></div>
            <div className="img_car"><img src={`https://nks.qravtojol.uz/image/${e?.photo}`} alt="" /></div>
            <div className="worker-item"><h5>{e.name}</h5></div>
            <div className="worker-item"><h5>{e.surname}</h5></div>
            <div className="worker-item"><h5>{e.father_name}</h5></div>
            <div className="worker-item"><h5>{e.date_of_birth}</h5></div>
            <div className="worker-item"><h5>{e.phone_number}</h5></div>
            <div className="worker-item"><h5>{e.ish_joy_lavozim}</h5></div>
          </div>
            <div className='btn_car-t0'>
              <button onClick={() => deleteDepartment(e.id)}>O'chirish</button>
            </div>
          </div>
          
        ))}
      </div>

      <div className="pagination">
        {Array.from({ length: Math.ceil(filteredWorkers?.length / workersPerPage) }, (_, i) => (
          <button key={i + 1} onClick={() => paginate(i + 1)} className={currentPage === i + 1 ? 'active1' : ''}>{i + 1}</button>
        ))}
      </div>
    </div>

  </div>
  );
}
